var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    id: "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    strokeWidth: 0,
    d: "M7.8,9.609l1.356,2.7s2.2-5.478,5.678-7.3c-0.085,1.3-.424,2.435.17,3.826-1.525.348-4.661,4.261-5.678,6.174A11.8,11.8,0,0,0,5,11.348Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rounded_Rectangle_4",
    "data-name": "Rounded Rectangle 4",
    fill: "none",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 3,
    ry: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBox);
export default __webpack_public_path__ + "static/media/check-box.f8b96fe47138d09cf76452bdbbedfc19.svg";
export { ForwardRef as ReactComponent };